import { Job } from 'src/app/interfaces/Job';

// Enqueue-order tag. Lets executeJobs recognise a dequeued job as
// superseded by a newer job still waiting, without touching Job.
interface TaggedJob {
  job: Job;
  seq: number;
}

export class DispatcherQueue {
  private jobs: TaggedJob[] = [];
  private isExecuting: boolean = false;
  private enqueued: number = 0;

  public run<K>(fn: () => Promise<K>): Promise<K> {
    return new Promise((resolve, reject) => {
      this.jobs.push({
        job: {
          fn,
          resolve,
          reject
        },
        seq: ++this.enqueued
      });

      if (!this.isExecuting) {
        this.executeJobs();
      }
    });
  }

  private async executeJobs(): Promise<void> {
    this.isExecuting = true;
    while (this.jobs.length > 0) {
      const next = this.jobs.shift()!;
      // Coalesce: the queue is FIFO, so the tail holds the newest waiting
      // seq. A dequeued job older than it is superseded and never runs.
      // Skipped callers resolve with undefined, never reject.
      if (this.jobs.length > 0 && this.jobs[this.jobs.length - 1].seq > next.seq) {
        next.job.resolve(undefined);
        continue;
      }
      try {
        const result = await next.job.fn();
        next.job.resolve(result);
      } catch (e) {
        next.job.reject(e);
      }
    }
    this.isExecuting = false;
  }
}
